/* eslint-disable @typescript-eslint/default-param-last */
import { ICreateQuestionModalAction } from "@/types/createQuestionModal.types";
import {
  END_INTERVIEW_FOR_ALL,
  HIDE_CREATE_QUESTION_MODAL,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  SHOW_CREATE_QUESTION_MODAL,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const createQuestionModalReducer = (
  state = initialState.createQuestionModal,
  action: ICreateQuestionModalAction,
) => {
  switch (action.type) {
    case SHOW_CREATE_QUESTION_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case HIDE_CREATE_QUESTION_MODAL:
      return {
        show: false,
        questionsDetails: null,
      };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.createQuestionModal;
    default:
      return state;
  }
};

export default createQuestionModalReducer;
